import styles from '../css/SkeletonCard.module.css';

const SkeletonCard = ({ fluid = false }) => (
  <div className={`${styles.skeletonWrapper} ${fluid ? styles.skeletonWrapperFluid : ''}`}>
    <div className={styles.skeletonImage} />
    <div className={styles.skeletonTitle} />
    <div className={styles.skeletonTitleShort} />
    <div className={styles.skeletonMeta} />
  </div>
);

export default SkeletonCard;
